import React from "react";
import "./Button.css";

/**
 * iCRAFTZ Design System · <Button>
 *
 * Props
 * ─────
 * variant  'primary' | 'ghost' | 'link'   default 'primary'
 * size     'sm' | 'md' | 'lg'             default 'md'
 * as       'button' | 'a'                 default 'button'
 * href     string (required when as='a')
 *
 * All native <button>/<a> attributes (onClick, disabled, aria-*, data-testid…)
 * pass through untouched. focus ring, hover, active states are baked in.
 */
export function Button({
  variant = "primary",
  size = "md",
  as = "button",
  className = "",
  children,
  ...rest
}) {
  const cls = ["icz-btn", `icz-btn--${variant}`, `icz-btn--${size}`, className]
    .filter(Boolean)
    .join(" ");
  if (as === "a") {
    return <a className={cls} {...rest}>{children}</a>;
  }
  return <button type="button" className={cls} {...rest}>{children}</button>;
}

export default Button;
